// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CodeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CodeIcon" ref={forwardedRef} {...props}>
      <path d="M10.865 3.443 7.5 16l1.449.388 3.364-12.557z" />
      <path d="M5.243 5.757 1 10l4.243 4.243 1.06-1.061L3.121 10l3.182-3.182z" />
      <path d="m19 10-4.243-4.243-1.06 1.061L16.879 10l-3.182 3.182 1.06 1.06z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const CodeIcon = /* @__PURE__ */ Object.assign(CodeIconComponent, {
  displayName: 'CodeIcon',
});
